import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

const { fontSizes } = THEME.typography;

export const styleSheet = StyleSheet.create({
	buttonGroup: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[12],
	},
	container: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: SPACE[20],
	},
	fileInput: {
		display: 'none',
	},
	goalsContainer: {
		paddingBottom: SPACE[40],
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[20],
	},
	label: {
		color: THEME.colors.text.main,
		fontSize: fontSizes.lg,
	},
	selectedUser: {
		color: THEME.colors.text.main,
		fontSize: fontSizes.lg,
	},
	userSearch: {
		width: 300,
	},
});
